import React from 'react';
import { fireErrorAnalytics } from '@atlassian/error-handling';
import { ErrorBoundary } from 'react-error-boundary';
import { useSelectedTemplatePreview } from './use-selected-template-preview';
import { type BlueprintData } from '../../../state/ui/blueprints/types';
import { type CreateEmbeddedPage } from './types';

type Props = {
	blueprints: BlueprintData[];
	contentId: string | null;
	isConfluenceActivationCompleteForPreselectedTemplate: boolean;
	createEmbeddedPage: CreateEmbeddedPage;
};

const SelectedTemplatePreview = (props: Props) => {
	useSelectedTemplatePreview(props);

	return null;
};

/**
 *
 * @param contentId
 * @param isConfluenceActivationCompleteForPreselectedTemplate
 * @returns
 */
export const PreselectedTemplate = ({
	contentId,
	isConfluenceActivationCompleteForPreselectedTemplate,
	blueprints,
	createEmbeddedPage,
}: Props) => {
	return (
		<ErrorBoundary
			FallbackComponent={() => <></>}
			onError={(error) => {
				fireErrorAnalytics({
					meta: {
						id: 'project-pages-embedded-confluence-error',
						packageName: '@atlassiansox/project-pages',
					},
					error: error as Error,
				});
			}}
		>
			<SelectedTemplatePreview
				contentId={contentId}
				isConfluenceActivationCompleteForPreselectedTemplate={
					isConfluenceActivationCompleteForPreselectedTemplate
				}
				blueprints={blueprints}
				createEmbeddedPage={createEmbeddedPage}
			/>
		</ErrorBoundary>
	);
};
